import { Snackbar } from '@mui/material';
import {
  RosterType,
  useRosterState,
} from 'amazon-chime-sdk-component-library-react';
import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { useMeetingContext } from '../../contexts/meeting/meetingContext';

function MeetingNotification() {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const rosterList = useRef<RosterType>({});
  const message = useRef('');
  const { roster: allRoster } = useRosterState();
  const { attendeeID: localAttendeeID } = useMeetingContext();

  useEffect(() => {
    const storedAttendeeIDs = Object.keys(rosterList.current);
    const attendeeIDs = Object.values(allRoster)
      .filter(
        (roster) => !roster.externalUserId?.startsWith('aws:MediaPipeline'),
      )
      .flatMap((roster) => roster.chimeAttendeeId);

    if (attendeeIDs === storedAttendeeIDs) {
      return;
    }

    const isAttendeeJoined = attendeeIDs > storedAttendeeIDs;

    let rosterChange = [];
    if (isAttendeeJoined) {
      rosterChange = _.difference(attendeeIDs, storedAttendeeIDs);
    } else {
      rosterChange = _.difference(storedAttendeeIDs, attendeeIDs);
    }
    rosterChange = rosterChange.filter(
      (attendeeID) => attendeeID !== localAttendeeID,
    );

    if (rosterChange[0]) {
      if (isAttendeeJoined) {
        message.current = intl.formatMessage(
          {
            defaultMessage: '{name} has joined the meeting',
          },
          {
            name: allRoster[rosterChange[0]].name,
          },
        );
      } else {
        message.current = intl.formatMessage(
          {
            defaultMessage: '{name} has left the meeting',
          },
          {
            name: rosterList.current[rosterChange[0]].name,
          },
        );
      }

      setOpen(true);
    }

    rosterList.current = allRoster;
  }, [allRoster, localAttendeeID, intl]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={2000}
      onClose={(_event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
          return;
        }

        setOpen(false);
        message.current = '';
      }}
      message={message.current}
    />
  );
}

export default MeetingNotification;
